// extracted by mini-css-extract-plugin
module.exports = {"notFoundContainer":"style_notFoundContainer__1hF8Z","content":"style_content__ji4G6","btnHome":"style_btnHome__2-814"};